import Header from "../Header"
import Footer from "../Footer"
import BannerImg from "../assets/Images/banner5-1920x450.png"
import BreadcrumbImg from "../assets/Images/nav-bar-bg.jpg"
import BottomLogoImg from "../assets/Images/bottom-logo.png"
import "./Events.scss"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import React, { useEffect, useState } from 'react';  
import ImageGallery from 'react-image-gallery';
import styles from "./index.css"
import Breadcrumbs from "../Breadcrumbs"

const Events = () => {
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [arr, setArr] = useState([1,2,3,4])
  function range(start, end) {
    return Array(end - start + 1).fill().map((_, idx) => start + idx)
  }

  useEffect(()=>{
    if (page === 41){
      setArr(range(page, page+ 1))
    }
    else{
      setArr(range(page, page+ 4))

    }
    
  },[page])

  const pics1 = [
    {
      original: './20 Jun 2021/5.jpg',
      thumbnail: './20 Jun 2021/5.jpg',
    },
    {
      original: './20 Jun 2021/2.jpg',
      thumbnail: './20 Jun 2021/2.jpg',
    },
    {
      original: './20 Jun 2021/3.jpg',
      thumbnail: './20 Jun 2021/3.jpg',
    },
    {
      original: './20 Jun 2021/4.jpg',
      thumbnail: './20 Jun 2021/4.jpg',
    },
    {
      original: './20 Jun 2021/1.jpg',
      thumbnail: './20 Jun 2021/1.jpg',
    },
  ];

  const pics2 = [
    {
      original: './9 Mar 2021/1.jpg',
      thumbnail: './9 Mar 2021/1.jpg',
    },
  ];

  const pics3 = [
  ];

  const pics4 = [
    {
      original: './22 Feb 2021/1.jpg',
      thumbnail: './22 Feb 2021/1.jpg',
    },
  ];

  const pics5 = [
    {
      original: './5 Feb 2021/1.jpg',
      thumbnail: './5 Feb 2021/1.jpg',
    },
  ];  
  const pics6 = [
    {
      original: './27 Jan 2021/1.jpg',
      thumbnail: './27 Jan 2021/1.jpg',
    }
  ];  
  const pics7 = [
    {
      original: './9 Mar 2021/1.jpg',
      thumbnail: './9 Mar 2021/1.jpg',
    },
  ];

  const pics8 = [
    {
      original: './10 Oct 2020/1.jpg',
      thumbnail: './10 Oct 2020/1.jpg',
    },
    {
      original: './10 Oct 2020/2.jpg',
      thumbnail: './10 Oct 2020/2.jpg',
    },
    {
      original: './10 Oct 2020/3.jpg',
      thumbnail: './10 Oct 2020/3.jpg',
    },
  ];

  const pics9 = [
    {
      original: './8 Jun 2020/101807745_949913498763221_7125430379846938779_n.jpg',
      thumbnail: './8 Jun 2020/101807745_949913498763221_7125430379846938779_n.jpg',
    },
  ];

  const pics10 = [
    {
      original: './9 Mar 2021/1.jpg',
      thumbnail: './9 Mar 2021/1.jpg',
    },
  ];

  const pics11 = [
    {
      original: './14 Dec 2019/78721482_809974949423744_6273515389028663296_n.jpg',
      thumbnail: './14 Dec 2019/78721482_809974949423744_6273515389028663296_n.jpg',
    },
    {
      original: './14 Dec 2019/79143748_809974969423742_8105595863084040192_n.jpg',
      thumbnail: './14 Dec 2019/79143748_809974969423742_8105595863084040192_n.jpg',
    },
    {
      original: './14 Dec 2019/79224378_809975049423734_7251441994508009472_n.jpg',
      thumbnail: './14 Dec 2019/79224378_809975049423734_7251441994508009472_n.jpg',
    },
    {
      original: './14 Dec 2019/79260968_809975026090403_7781874028976799744_n.jpg',
      thumbnail: './14 Dec 2019/79260968_809975026090403_7781874028976799744_n.jpg',
    },
  ];

  const pics12 = [
    {
      original: './25 Nov 2019/75543521_793326537755252_5025648401073569792_n.jpg',
      thumbnail: './25 Nov 2019/75543521_793326537755252_5025648401073569792_n.jpg',
    },
    {
      original: './25 Nov 2019/76990433_793143897773516_3905107964876292096_n.jpg',
      thumbnail: './25 Nov 2019/76990433_793143897773516_3905107964876292096_n.jpg',
    },
    {
      original: './25 Nov 2019/77135923_793143907773515_1415196912352493568_n.jpg',
      thumbnail: './25 Nov 2019/77135923_793143907773515_1415196912352493568_n.jpg',
    },
  ];

  const pics13 = [
    {
      original: './9 Nov 2019 ¡øÆy/73238404_779631472458092_9172468144592125952_n.jpg',
      thumbnail: './9 Nov 2019 ¡øÆy/73238404_779631472458092_9172468144592125952_n.jpg',
    },
    {
      original: './9 Nov 2019 ¡øÆy/74483241_779631435791429_9050392439461773312_n.jpg',
      thumbnail: './9 Nov 2019 ¡øÆy/74483241_779631435791429_9050392439461773312_n.jpg',
    },
    {
      original: './9 Nov 2019 ¡øÆy/74634690_779631432458096_690956608955482112_n.jpg',
      thumbnail: './9 Nov 2019 ¡øÆy/74634690_779631432458096_690956608955482112_n.jpg',
    },
    {
      original: './9 Nov 2019 ¡øÆy/75328589_779631442458095_6515660035949854720_n.jpg',
      thumbnail: './9 Nov 2019 ¡øÆy/75328589_779631442458095_6515660035949854720_n.jpg',
    },
    {
      original: './9 Nov 2019 ¡øÆy/76644594_779631529124753_3768993484829097984_n.jpg',
      thumbnail: './9 Nov 2019 ¡øÆy/76644594_779631529124753_3768993484829097984_n.jpg',
    },
  ];

  const pics14 = [
    {
      original: './9 Nov 2019/1.jpg',
      thumbnail: './9 Nov 2019/1.jpg',
    },
    {
      original: './9 Nov 2019/2.jpg',
      thumbnail: './9 Nov 2019/2.jpg',
    },
    {
      original: './9 Nov 2019/3.jpg',
      thumbnail: './9 Nov 2019/3.jpg',
    },
    {
      original: './9 Nov 2019/4.jpg',
      thumbnail: './9 Nov 2019/4.jpg',
    },
    {
      original: './9 Nov 2019/5.jpg',
      thumbnail: './9 Nov 2019/5.jpg',
    },
  ];

  const pics15 = [
    {
      original: './6 Nov 2019/6 Nov 2019 (1).jpg',
      thumbnail: './6 Nov 2019/6 Nov 2019 (1).jpg',
    },
    {
      original: './6 Nov 2019/6 Nov 2019 (2).jpg',
      thumbnail: './6 Nov 2019/6 Nov 2019 (2).jpg',
    },
    {
      original: './6 Nov 2019/6 Nov 2019 (3).jpg',
      thumbnail: './6 Nov 2019/6 Nov 2019 (3).jpg',
    },
    {
      original: './6 Nov 2019/6 Nov 2019 (4).jpg',
      thumbnail: './6 Nov 2019/6 Nov 2019 (4).jpg',
    },
    {
      original: './6 Nov 2019/6 Nov 2019 (5).jpg',
      thumbnail: './6 Nov 2019/6 Nov 2019 (5).jpg',
    },
  ];

  const pics16 = [
    {
      original: './9 Oct 2019/9 Oct 2019 (1).jpg',
      thumbnail: './9 Oct 2019/9 Oct 2019 (1).jpg',
    },
    {
      original: './9 Oct 2019/9 Oct 2019 (3).jpg',
      thumbnail: './9 Oct 2019/9 Oct 2019 (3).jpg',
    },
    {
      original: './9 Oct 2019/9 Oct 2019 (4).jpg',
      thumbnail: './9 Oct 2019/9 Oct 2019 (4).jpg',
    }
  ];

  const pics17 = [
    {
      original: './9 Oct 2019/9 Oct 2019 (1).jpg',
      thumbnail: './9 Oct 2019/9 Oct 2019 (1).jpg',
    },
    {
      original: './9 Oct 2019/9 Oct 2019 (3).jpg',
      thumbnail: './9 Oct 2019/9 Oct 2019 (3).jpg',
    },
    {
      original: './9 Oct 2019/9 Oct 2019 (4).jpg',
      thumbnail: './9 Oct 2019/9 Oct 2019 (4).jpg',
    }
  ];

  const pics18 = [
    {
      original: './27 Sep 2019/27 Sep 2019 (1).jpg',
      thumbnail: './27 Sep 2019/27 Sep 2019 (1).jpg',
    },
    {
      original: './27 Sep 2019/27 Sep 2019 (2).jpg',
      thumbnail: './27 Sep 2019/27 Sep 2019 (2).jpg',
    }
  ];

  const pics19 = [
    {
      original: './16 Jul 2019/16 Jul 2019 (1).jpg',
      thumbnail: './16 Jul 2019/16 Jul 2019 (1).jpg',
    },
    {
      original: './16 Jul 2019/16 Jul 2019 (2).jpg',
      thumbnail: './16 Jul 2019/16 Jul 2019 (2).jpg',
    },
    {
      original: './16 Jul 2019/16 Jul 2019 (3).jpg',
      thumbnail: './16 Jul 2019/16 Jul 2019 (3).jpg',
    },
    {
      original: './16 Jul 2019/16 Jul 2019 (4).jpg',
      thumbnail: './16 Jul 2019/16 Jul 2019 (4).jpg',
    },
    {
      original: './16 Jul 2019/16 Jul 2019 (5).jpg',
      thumbnail: './16 Jul 2019/16 Jul 2019 (5).jpg',
    }
  ];

  const pics20 = [
    {
      original: './3 Jun 2019/3 Jun 2019 (1).jpg',
      thumbnail: './3 Jun 2019/3 Jun 2019 (1).jpg',
    },
    {
      original: './3 Jun 2019/3 Jun 2019 (2).jpg',
      thumbnail: './3 Jun 2019/3 Jun 2019 (2).jpg',
    },
    {
      original: './3 Jun 2019/3 Jun 2019 (3).jpg',
      thumbnail: './3 Jun 2019/3 Jun 2019 (3).jpg',
    },
    {
      original: './3 Jun 2019/3 Jun 2019 (4).jpg',
      thumbnail: './3 Jun 2019/3 Jun 2019 (4).jpg',
    },
    {
      original: './3 Jun 2019/3 Jun 2019 (5).jpg',
      thumbnail: './3 Jun 2019/3 Jun 2019 (5).jpg',
    },
    {
      original: './3 Jun 2019/3 Jun 2019 (6).jpg',
      thumbnail: './3 Jun 2019/3 Jun 2019 (6).jpg',
    },
    {
      original: './3 Jun 2019/3 Jun 2019 (7).jpg',
      thumbnail: './3 Jun 2019/3 Jun 2019 (7).jpg',
    },
    {
      original: './3 Jun 2019/3 Jun 2019 (8).jpg',
      thumbnail: './3 Jun 2019/3 Jun 2019 (8).jpg',
    },
    {
      original: './3 Jun 2019/3 Jun 2019 (9).jpg',
      thumbnail: './3 Jun 2019/3 Jun 2019 (9).jpg',
    },
    {
      original: './3 Jun 2019/3 Jun 2019 (10).jpg',
      thumbnail: './3 Jun 2019/3 Jun 2019 (10).jpg',
    },
  ];

  const pics21 = [
    {
      original: './20 May 2019/20 May 2019 (1).jpg',
      thumbnail: './20 May 2019/20 May 2019 (1).jpg',
    },
    {
      original: './20 May 2019/20 May 2019 (2).jpg',
      thumbnail: './20 May 2019/20 May 2019 (2).jpg',
    }
  ];

  const pics22 = [
    {
      original: './15 Apr 2019/15 Apr 2019 (1).jpg',
      thumbnail: './15 Apr 2019/15 Apr 2019 (1).jpg',
    },
    {
      original: './15 Apr 2019/15 Apr 2019 (2).jpg',
      thumbnail: './15 Apr 2019/15 Apr 2019 (2).jpg',
    },
    {
      original: './15 Apr 2019/15 Apr 2019 (3).jpg',
      thumbnail: './15 Apr 2019/15 Apr 2019 (3).jpg',
    }
  ];

  const pics23 = [
    {
      original: './16 Mar 2019/16 Mar 2019 (1).jpg',
      thumbnail: './16 Mar 2019/16 Mar 2019 (1).jpg',
    },
    {
      original: './16 Mar 2019/16 Mar 2019 (2).jpg',
      thumbnail: './16 Mar 2019/16 Mar 2019 (2).jpg',
    },
    {
      original: './16 Mar 2019/16 Mar 2019 (3).jpg',
      thumbnail: './16 Mar 2019/16 Mar 2019 (3).jpg',
    }
  ];

  const pics24 = [
    {
      original: './13 Mar 2019/13 Mar 2019 (1).jpg',
      thumbnail: './13 Mar 2019/13 Mar 2019 (1).jpg',
    }
  ];

  const pics25 = [
    {
      original: './29 Nov 2018/29 Nov 2018 (1).jpg',
      thumbnail: './29 Nov 2018/29 Nov 2018 (1).jpg',
    },
    {
      original: './29 Nov 2018/29 Nov 2018 (2).jpg',
      thumbnail: './29 Nov 2018/29 Nov 2018 (2).jpg',
    }
  ];

  const pics26 = [];

  const pics27 = [
    {
      original: './29 Nov 2018/29 Nov 2018 (1).jpg',
      thumbnail: './29 Nov 2018/29 Nov 2018 (1).jpg',
    }
  ];

  const pics28 = [
    {
      original: './15 Oct 2018/15 Oct 2018 (1).jpg',
      thumbnail: './15 Oct 2018/15 Oct 2018 (1).jpg',
    },
    {
      original: './15 Oct 2018/15 Oct 2018 (2).jpg',
      thumbnail: './15 Oct 2018/15 Oct 2018 (2).jpg',
    },
    {
      original: './15 Oct 2018/15 Oct 2018 (3).jpg',
      thumbnail: './15 Oct 2018/15 Oct 2018 (3).jpg',
    },
    {
      original: './15 Oct 2018/15 Oct 2018 (4).jpg',
      thumbnail: './15 Oct 2018/15 Oct 2018 (4).jpg',
    },
    {
      original: './15 Oct 2018/15 Oct 2018 (5).jpg',
      thumbnail: './15 Oct 2018/15 Oct 2018 (5).jpg',
    }

  ];

  const pics29 = [
    {
      original: './19 Jun 2018/19 Jun 2018 (1).jpg',
      thumbnail: './19 Jun 2018/19 Jun 2018 (1).jpg',
    },
    {
      original: './19 Jun 2018/19 Jun 2018 (2).jpg',
      thumbnail: './19 Jun 2018/19 Jun 2018 (2).jpg',
    },
    {
      original: './19 Jun 2018/19 Jun 2018 (3).jpg',
      thumbnail: './19 Jun 2018/19 Jun 2018 (3).jpg',
    },
  ];

  const pics30 = [
    {
      original: './14 May 2018/14 May 2018.jpg',
      thumbnail: './14 May 2018/14 May 2018.jpg',
    },
    {
      original: './14 May 2018/14 May 2018 (1).jpg',
      thumbnail: './14 May 2018/14 May 2018 (1).jpg',
    },
    {
      original: './14 May 2018/14 May 2018 (2).jpg',
      thumbnail: './14 May 2018/14 May 2018 (2).jpg',
    },
    {
      original: './14 May 2018/14 May 2018 (3).jpg',
      thumbnail: './14 May 2018/14 May 2018 (3).jpg',
    },
    {
      original: './14 May 2018/14 May 2018 (4).jpg',
      thumbnail: './14 May 2018/14 May 2018 (4).jpg',
    }
  ];

  const pics31 = [
    {
      original: './14 Mar 2018/14 Mar 2018 (1).jpg',
      thumbnail: './14 Mar 2018/14 Mar 2018 (1).jpg',
    }
  ];

  const pics32 = [
    {
      original: './16 Oct 2017/16 Oct 2017 (1).jpg',
      thumbnail: './16 Oct 2017/16 Oct 2017 (1).jpg',
    },
    {
      original: './16 Oct 2017/16 Oct 2017 (2).jpg',
      thumbnail: './16 Oct 2017/16 Oct 2017 (2).jpg',
    },
  ];

  const pics33 = [
    {
      original: './14 Oct 2017/14 Oct 2017 (1).jpg',
      thumbnail: './14 Oct 2017/14 Oct 2017 (1).jpg',
    }
  ];

  const pics34 = [
    {
      original: './19 Sep 2017/19 Sep 2017 (1).jpg',
      thumbnail: './19 Sep 2017/19 Sep 2017 (1).jpg',
    },
    {
      original: './19 Sep 2017/19 Sep 2017 (2).jpg',
      thumbnail: './19 Sep 2017/19 Sep 2017 (2).jpg',
    },
    {
      original: './19 Sep 2017/19 Sep 2017 (3).jpg',
      thumbnail: './19 Sep 2017/19 Sep 2017 (3).jpg',
    },
  ];

  const pics35 = [
    {
      original: './10 Mar 2017/10 Mar 2017 (1).jpg',
      thumbnail: './10 Mar 2017/10 Mar 2017 (1).jpg',
    },
    {
      original: './10 Mar 2017/10 Mar 2017 (2).jpg',
      thumbnail: './10 Mar 2017/10 Mar 2017 (2).jpg',
    },
    {
      original: './10 Mar 2017/10 Mar 2017 (3).jpg',
      thumbnail: './10 Mar 2017/10 Mar 2017 (3).jpg',
    },
  ];

  const pics36 = [
    {
      original: './28 Feb 2017/28 Feb 2017.jpg',
      thumbnail: './28 Feb 2017/28 Feb 2017.jpg',
    },
  ];

  const pics37 = [
    {
      original: './6 Dec 2016/6 Dec 2016 (1).jpg',
      thumbnail: './6 Dec 2016/6 Dec 2016 (1).jpg',
    },
  ];

  const pics38 = [
    {
      original: './12 Oct 2016/12 Oct 2016 (1).jpg',
      thumbnail: './12 Oct 2016/12 Oct 2016 (1).jpg',
    },
    {
      original: './12 Oct 2016/12 Oct 2016 (2).jpg',
      thumbnail: './12 Oct 2016/12 Oct 2016 (2).jpg',
    },
    {
      original: './12 Oct 2016/12 Oct 2016 (3).jpg',
      thumbnail: './12 Oct 2016/12 Oct 2016 (3).jpg',
    },
    {
      original: './12 Oct 2016/12 Oct 2016 (4).jpg',
      thumbnail: './12 Oct 2016/12 Oct 2016 (4).jpg',
    },
    {
      original: './12 Oct 2016/12 Oct 2016 (5).jpg',
      thumbnail: './12 Oct 2016/12 Oct 2016 (5).jpg',
    },
    {
      original: './12 Oct 2016/12 Oct 2016 (6).jpg',
      thumbnail: './12 Oct 2016/12 Oct 2016 (6).jpg',
    },
  ];

  const pics39 = [
    {
      original: './11 Oct 2016/11 Oct 2016 (1).jpg',
      thumbnail: './11 Oct 2016/11 Oct 2016 (1).jpg',
    },
    {
      original: './11 Oct 2016/11 Oct 2016 (2).jpg',
      thumbnail: './11 Oct 2016/11 Oct 2016 (2).jpg',
    },
  ];

  const pics40 = [
    {
      original: './11 Oct 2016/11 Oct 2016 (1).jpg',
      thumbnail: './11 Oct 2016/11 Oct 2016 (1).jpg',
    }
  ];

  const pics41 = [
    {
      original: './12 Jun 2016/12 Jun 2016.jpg',
      thumbnail: './12 Jun 2016/12 Jun 2016.jpg',
    }
  ];

  const pics42 = [
    {
      original: './11 May 2016/11 May 2016.jpg',
      thumbnail: './11 May 2016/11 May 2016.jpg',
    }
  ];

  useEffect(()=>{
    // const w = window.document.getElementsByName('.image-gallery-slide .image-gallery-image')
    // w.style.maxHeight = '60vh'
  },[])

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">{t("events_page_header")}</h1>
          <p className="banner-subtitle">{t("events_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_events_page_link1")}</Link>
        <span>{t("breadcrumbs_events_page_span")}</span>
        <Link>{t("breadcrumbs_events_page_link2")}</Link>
      </Breadcrumbs>

      <main className="events-main-container">
        {
          arr.map((e) => 
            <article className="events-item" key={e}>
              <div className="events-text">
                <header className="event-header">
                  <div className="event-date">{t("events_p"+(e)+"_date")}</div>
                  <div className="event-divider"></div>
                </header>
                <div className="event-content">
                  <p className="event-paragraph">{t("events_p"+e+"_1")}</p>
                  { (e === 1 || e === 3 || e === 4 || e === 5 || e === 6 || e === 7) &&
                  <p className="event-paragraph">{t("events_p"+(e)+"_2")}</p>}
                  { (e === 5 || e === 1) &&
                  <p className="event-paragraph">{t("events_p"+(e)+"_3")}</p> }
                  { (e === 5 || e === 1) &&
                  <p className="event-paragraph">{t("events_p"+(e)+"_4")}</p> }
                  { (e === 5) &&
                  <p className="event-paragraph">{t("events_p"+(e)+"_5")}</p> }
                </div>
              </div>
              <div className="events-gallery">
                <ImageGallery showPlayButton={false} items={
                                                              e === 1 ? pics1: e === 2 ? pics2: e === 3 ? pics3 : 
                                                              e === 4 ? pics4: e === 5 ? pics5: e === 6 ? pics6 :
                                                              e === 7 ? pics7: e === 8 ? pics8: e === 9 ? pics9 :
                                                              e === 10 ? pics10: e === 11 ? pics11: e === 12 ? pics12 :
                                                              e === 13 ? pics13: e === 14 ? pics14: e === 15 ? pics15 :
                                                              e === 16 ? pics16: e === 17 ? pics17: e === 18 ? pics18 :
                                                              e === 19 ? pics19: e === 20 ? pics21: e === 21 ? pics21 :
                                                              e === 22 ? pics22: e === 23 ? pics23: e === 24 ? pics24 :
                                                              e === 25 ? pics25: e === 26 ? pics26: e === 27 ? pics27 :
                                                              e === 28 ? pics28: e === 29 ? pics29: e === 30 ? pics30 :
                                                              e === 31 ? pics31: e === 32 ? pics32: e === 33 ? pics33 :
                                                              e === 34 ? pics34: e === 35 ? pics35: e === 36 ? pics36 :
                                                              e === 37 ? pics37: e === 38 ? pics38: e === 39 ? pics39 :
                                                              e === 40 ? pics40: e === 41 ? pics41: pics42
                                                            }  />
              </div>
            </article>
          )
        }
        
        <hr className="events-divider" />
        
        <nav className="pagination-container">
          <button className={page === 1 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(1) }>1</button>
          <button className={page === 5 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(5)}>2</button>
          <button className={page === 9 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(9)}>3</button>
          <button className={page === 13 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(13)}>4</button>
          <button className={page === 17 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(17)}>5</button>
          <button className={page === 21 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(21)}>6</button>
          <button className={page === 25 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(25)}>7</button>
          <button className={page === 29 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(29)}>8</button>
          <button className={page === 33 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(33)}>9</button>
          <button className={page === 37 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(37)}>10</button>
          <button className={page === 41 ? 'pagination-btn active' : 'pagination-btn'} onClick={ () => setPage(41)}>11</button>
          <button onClick={ () => setPage(page === 41 ? 1 : page+4)} className="pagination-btn next-btn">Next</button>
        </nav>
      </main>
    
      <section className="temporary">
        <img src={BottomLogoImg} alt="" />
      </section>
      <div className="pagination-container">
        <button className={page === 1 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(1) }>1</button>
        <button className={page === 5 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(5)}>2</button>
        <button className={page === 9 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(9)}>3</button>
        <button className={page === 13 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(13)}>4</button>
        <button className={page === 17 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(17)}>5</button>
        <button className={page === 21 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(21)}>6</button>
        <button className={page === 25 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(25)}>7</button>
        <button className={page === 29 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(29)}>8</button>
        <button className={page === 33 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(33)}>9</button>
        <button className={page === 37 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(37)}>10</button>
        <button className={page === 41 ? 'btnsClicked' : 'btnsss'} onClick={ () => setPage(41)}>11</button>
        <button  onClick={ () => setPage(page === 41 ? 1 : page+4)} className="btnsClicked">Next</button>
      </div>
    
    


      <Footer />
    </>
  )
}

export default Events
